export default "/images/hash.svg?71ec9b1867e42a90dd12ddb6b9568af2";